<template>
  <div>    
      <div class="row">
        <div class="col-md-12" style="margin-top: -40px;">
            <graficopie :rotulo="'DETALHES:'"
                        :legendas="legendasmarcas"
                        :dados="dadosmarcas"
            ></graficopie>
        </div>
        <div class="col-md-12">
            <ul style="padding-left: 0px; margin-bottom: 0px; margin-top: -40px; height: 61px; overflow:auto;">
                <li v-for="(item, indice) in dadosmarcas" :key="indice" class="li-item-card-dash" style="height: 15px;">
                    <span class="txt-item-card-dash-grafico">{{item.name }}</span>
                    <span class="txt-item-card-dash-grafico" style="float: right;">{{ mtdformatavalordecimal(parseFloat(item.value)) }} ({{ mtdformatavalordecimal(parseFloat(item.value) / parseFloat(totalgeralvenda) * 100, '') }}%)
                    </span>
                </li>
            </ul>                                            
        </div>
      </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import util from '../../utilitarios/util';
import GraficoPie from '../../components/cmpgraficopie.vue';
import Skeletondashboard from '../../components/cmpskeletondashboard2.vue';
export default {
  name: "vendasmarcas",

  components:{
    'graficopie'		: GraficoPie,
    'dashboard_skeleton'   : Skeletondashboard
  },

  data : function name(params) {
    return {
        legendasmarcas : [],
      
        isloading               : false,  
        usuariologado           : this.$store.state.usuario,
        dadosmarcas        : []
        

    }
   
  },
  props: [
    'utodasfiliais',
    'idfilialmeta',
    'pdtini',
    'pdtfim',
    'lstfiliais',
    
  ],
  methods:{
        mtdformatavalordecimal(valor){
				  return util.formatarvalor(valor, '');
        },
        mtdrelatoriomapavendas(){
            let vself   = this;
            let filtro  = ' and p.dtfatura between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtro  = filtro  + ' and p.idfilial in (' + stringfilial + ')';
            }
            let filtrorecebimento       = ' and t.dthrlancamento between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';
            if (vself.lstfiliais.length > 0) {
                let stringfilial = vself.lstfiliais.join(',');
                filtrorecebimento  = filtrorecebimento  + ' and p.idfilial in (' + stringfilial + ')';
            }
            let vizualiza = [0, 5];
            
            // let loader      			= vself.$loading.show();
            vself.$emit('handlerLoader', true);
            let parametros  			= [
                {parametro: 'idclientesac',         valor  : vself.$store.state.filialpadrao.idcliente},
                {parametro: 'op',           	      valor : 'mapavendas'},
                {parametro: 'agrupgrupo',           valor : vself.agrupamentogrupo},
                {parametro: 'vizualiza',            valor : vizualiza},
                {parametro: 'filtro', 	            valor : filtro},
                {parametro: 'filiais',      valor : JSON.stringify(vself.lstfiliais)},
            ];
            let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtrelatorios.php');
            retorno.then(function (response) {
                vself.totalgeralcusto     = response.data.totalgeralcusto;
                vself.totalgeralvenda     = response.data.totalgeralvenda;
                vself.totaldiferenca      = response.data.totaldiferenca;
                vself.margemgeral         = response.data.margemgeral; 
                vself.vtotalrecebimentos  = response.data.totalrecebimentos;
                vself.vtotalabatecredito  = response.data.totalabatecredito;
                // vself.vtotalformas        = response.data.totalformas; 

                vself.lstvolumecb         = response.data.volumecb;
                vself.vtotutilizado       = response.data.totutilizado;
                vself.vtotdisponivel      = response.data.totdisponivel;



                // vself.totalqtdvenda    = 0;//reseta as variaveis
                // vself.totalticketmedio = 0;
                // for (let index = 0; index < vself.lstmapavendas.length; index++) {
                //     vself.totalqtdvenda    = vself.totalqtdvenda    + parseInt(vself.lstmapavendas[index].qtdpedidos)
                //     vself.totalticketmedio = vself.totalticketmedio + vself.lstmapavendas[index].tiketmedio
                // }
                


                // vself.dadosvendedor       = response.data.vendedores;
                // vself.legendasvendedor    = util.gerardadoslegendagrafico(vself.dadosvendedor);                    

                vself.dadosmarcas         = response.data.marcas;                    
                vself.legendasmarcas      = util.gerardadoslegendagrafico(vself.dadosmarcas);
                
                // vself.dadosgrupos         = response.data.grupos;
                // vself.legendasgrupos      = util.gerardadoslegendagrafico(vself.dadosgrupos);                    
                
                // vself.dadossubgrupos      = response.data.subgrupos;
                // vself.legendassubgrupos   = util.gerardadoslegendagrafico(vself.dadossubgrupos);                    

                // vself.dadossetores        = response.data.setores;
                // vself.legendassetores     = util.gerardadoslegendagrafico(vself.dadossetores);                                        
                
                // vself.dadosplanos         = response.data.planos;
                // vself.legendasplanos      = util.gerardadoslegendagrafico(vself.dadosplanos); 

                // vself.dadosplanosgrupo    = response.data.planosagrupado;
                // vself.legendasplanosgrupo = util.gerardadoslegendagrafico(vself.dadosplanosgrupo); 
                
                // vself.dadosformas         = response.data.formas;                                
                // vself.legendasformas      = util.gerardadoslegendagrafico(vself.dadosformas);                    

                // vself.dadosfilial         = response.data.filiais;
                // vself.legendasfilial      = util.gerardadoslegendagrafico(vself.dadosfilial);       
                
                // vself.dadosmunicipios     = response.data.municipios;
                // vself.legendasmunicipios  = util.gerardadoslegendagrafico(vself.dadosmunicipios);  

                // vself.dadoscategorias     = response.data.categorias;
                // vself.legendascategorias  = util.gerardadoslegendagrafico(vself.dadoscategorias);  


                //gera os dados para o gráfico de linha custo/venda
                // vself.agrupamentograficoline = util.gerarseriegrafico(vself.lstmapavendas, 'agrupamento');
                // let seriecusto = {
                //     name: 'Custo',
                //     type: 'line',
                //     data: util.gerarseriegrafico(vself.lstmapavendas, 'totalcusto')
                // };
                // let serievenda = {
                //     name: 'Venda',
                //     type: 'line',
                //     data: util.gerarseriegrafico(vself.lstmapavendas, 'totalvenda')
                // };                    
                // vself.seriesgraficoline = [];
                // vself.seriesgraficoline.push(seriecusto);
                // vself.seriesgraficoline.push(serievenda);

                // loader.hide();		
                vself.$emit('handlerLoader', false);
            }).catch(function (response) {
                vself.lstmapavendas       = [];
                vself.totalgeralcusto     = 0;
                vself.totalgeralvenda     = 0;
                vself.totaldiferenca      = 0;
                vself.margemgeral         = 0; 
                vself.vtotalrecebimentos  = 0;
                vself.vtotalabatecredito  = 0;
                // vself,vtotalformas        = 0;
                vself.dadosvendedor       = [];
                vself.legendasvendedor    = []                    

                vself.dadosmarcas         = [];                    
                vself.legendasmarcas      = []
                
                vself.dadosgrupos         = [];
                vself.legendasgrupos      = []                    
                
                vself.dadossubgrupos      = [];
                vself.legendassubgrupos   = []                    
                    
                vself.dadosplanos         = [];
                vself.legendasplanos      = [] 

                vself.dadosplanosgrupo    = [];
                vself.legendasplanosgrupo = []                    
                
                vself.dadosformas         = [];                                
                vself.legendasformas      = [];                                                                       

                vself.dadosfilial         = [];
                vself.legendasfilial      = []; 
                
                vself.dadosmunicipios     = [];
                vself.legendasmunicipios  = [];
                // loader.hide();
                vself.$emit('handlerLoader', false);
            });    
        },
  },
  mounted(){


    setTimeout(() => {
         this.mtdrelatoriomapavendas();
    }, 3000);
   
  },
  computed:{
            
  },
}
</script>
